import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageToggle.css';

/**
 * LanguageToggle - Pill-style language switcher component
 *
 * Features:
 * - Pill-style toggle with "EN | ES"
 * - Active option: navy background, white text
 * - Inactive option: transparent background, navy text
 * - Border: 1px solid navy, border-radius: 20px
 * - Click target at least 44x44px for accessibility
 */
export default function LanguageToggle() {
  const { i18n, t } = useTranslation();

  const currentLanguage = i18n.language;

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div
      className="language-toggle"
      role="group"
      aria-label={t('languageToggle.switchLanguage')}
    >
      <button
        type="button"
        className={`language-option ${currentLanguage === 'en' ? 'active' : ''}`}
        onClick={() => handleLanguageChange('en')}
        aria-pressed={currentLanguage === 'en'}
        aria-label="English"
      >
        {t('languageToggle.english')}
      </button>
      <span className="language-divider" aria-hidden="true">|</span>
      <button
        type="button"
        className={`language-option ${currentLanguage === 'es' ? 'active' : ''}`}
        onClick={() => handleLanguageChange('es')}
        aria-pressed={currentLanguage === 'es'}
        aria-label="Español"
      >
        {t('languageToggle.spanish')}
      </button>
    </div>
  );
}
